const formatPhone = (phone) => {
    if (!phone) {
        return '';
    }
    const tmp = phone.replace(/\D/g, '');
    return `+${tmp.slice(0, 1)} ${tmp.slice(1, 4)} ${tmp.slice(4, 7)}-${tmp.slice(7, 9)}-${tmp.slice(9)}`;
};
const getUserName = (user) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { nickname, first_name = '', phone_number, email } = user;
    const name = first_name.trim();
    if (name.length > 0)
        return name;
    if (nickname && nickname.trim().length > 0)
        return nickname;
    if (phone_number && phone_number.length > 0)
        return formatPhone(phone_number);
    if (email && email.length > 0)
        return email;
    return undefined;
};

export { formatPhone, getUserName };
//# sourceMappingURL=user.js.map
